import React, { useEffect, useRef, useState } from "react";
import { toPng } from "html-to-image";
import './PlayerCardWidget.css';
import PrimaryButton from "./ui/PrimaryButton";
import LabelText from "./ui/LabelText";
import { fetchData } from "./services/api";
import IApiResponse from "./types/IApiResponse";
import apiUrls from "./config/apiUrls";
import handleApiResponse from "./utils/handleApiResponse";
import { IPlayerCardWidgetData } from "./types/IPlayerCardDetail";
import YellowCardSvg from "./assets/event_icons/Yellow_card.png";
import RedCardSvg from "./assets/event_icons/red_card.png";
import { ModuleSpinner } from "./ui/LoadingSpinner/ModuleSpinner";

const PlayerCard: React.FC = () => {

  const testParams = window.location.search;
  const [playerCardData, setPlayerCardData] = React.useState<IPlayerCardWidgetData>();
  const [isPlayerCardLoading , setIsPlayerCardLoading] = useState<boolean>(true);
  const playerId = new URLSearchParams(testParams).get("playerId");
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  const handleFileChange = (e : any) => {
      setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
      if (!file) {
        alert("Please select a file first");
        return;
      }
      const formData = new FormData();
      formData.append("imageFile", file);
      try {
        setIsPlayerCardLoading(true);
        const response = await fetch(
          `${apiUrls.GetPlayerCardImage}/${playerId}`,
          {
            method: "POST",
            headers: {
              Accept: "*/*", 
            },
            body: formData,
          }
        );
        if(response){setIsPlayerCardLoading(false);}
        if (!response.ok) {
          setIsPlayerCardLoading(false);
          throw new Error(`Upload failed: ${response.status}`);
        }
        const responseData = await response.json();
        // navigate(responseData.data)
        window.location.href = responseData.data;
      } catch (error) {
        setIsPlayerCardLoading(false);
        console.error("Upload error:", error);
      }

  };

  const htmlToImageConvert = () => {
    if (!elementRef.current) return;

    const scale = 8; // increase for higher resolution
    const node = elementRef.current;

    // Get the original size of the element
    const originalWidth = node.clientWidth ;
    const originalHeight = node.clientHeight ;

    toPng(node, {
      cacheBust: true,
      width: originalWidth * scale,
      height: originalHeight * scale,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        width: `${originalWidth}px`,
        height: `${originalHeight}px`,
      },
    })
      .then((dataUrl: string) => {
        const link = document.createElement("a");
        link.download = `${playerCardData?.playerName}.png`;
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error("Image export failed:", err);
      });
  };


  useEffect(() => {
      const fetchClubFinancialData = async () => {
        try {
          // startLoading();
          setIsPlayerCardLoading(true);
          const response: IApiResponse<IPlayerCardWidgetData> = await fetchData(
            `${apiUrls["GetPlayerNewCardDetails"]}${testParams}`
          );
          handleApiResponse(
            response,
            (teamsData) => {
              if (teamsData) {
                setIsPlayerCardLoading(false);
                setPlayerCardData(teamsData)
              //   setClubFinancialData(teamsData); // Update state only if the data is available
              }
            },
            (error) => {
              setIsPlayerCardLoading(false);
              console.error("Error fetching club card Data:", error);
            }
          );
        } catch (error) {
          setIsPlayerCardLoading(false);
          console.error("Error fetching club financial data:", error);
        } finally {
          // stopLoading();
        }
      };
        fetchClubFinancialData();
        // htmlToImageConvert()
  }, []);

  const getBackgroundColor = (performanceValue?: number) => {
    if (performanceValue == null) {
      return "none";
    }
    
    if (performanceValue > 0 && performanceValue <= 24.99) {
      return "var(--UI-red-500, #FF3864)";
    } else if (performanceValue >= 25 && performanceValue <= 49.99) {
      return "var(--Brand-orange-500, #FF7800)";
    } else if (performanceValue >= 50 && performanceValue <= 74.99) {
      return "var(--UI-yellow-500, #F2E94E)";
    } else if (performanceValue >= 75 && performanceValue <= 87.99) {
      return "#C9F0B6";
    } else if (performanceValue >= 88 && performanceValue <= 98.99) {
      return "var(--Brand-green-2-500, #4AF075)";
    } else if (performanceValue >= 99) {
      return "#00D1A8";
    } else if (performanceValue === 0) {
      return "#DADADA";
    } else {
      return "red";
    }
  };
      
    return (
      <div  style={{ background: "#ffffffff", minHeight: "100vh", display: "flex",flexDirection:'column', justifyContent: "center", alignItems: "center" , gap: "20px"}}>
        {/* <div className='player-search-data'>
              <div className='container active'>
                  <SearchInput
                      handleSearch={handleSearch}
                      handleClear={handleClear}
                      placeholder='Search players'
                      fontSize='32px'
                      type="SearchPlayer"
                      clearInput={clearInput}
                      autoFocus={false}
                  />
              </div>
              {renderSearchPlayers()}
        </div> */}
        <input type="file" onChange={handleFileChange} />
        <PrimaryButton onClick={handleUpload} disabled={uploading} label="Submit"></PrimaryButton>
          <div ref={elementRef} className="card"  >
            {/* Profile Section */}
            <div className="profile-header">
              <img
              className="profile-header-img"
              src={
                new URLSearchParams(testParams).get('Url') 
                  ? new URLSearchParams(testParams).get('Url') || undefined
                  : `${apiUrls.ProxyImage}?url=${playerCardData?.playerImage!}`
              }
                alt="player image"
              />
              {/* <div style={{width:'150px',height: '170px'}}></div> */}
              
              <div className="player-info">
                <div className="player-name-widget">
                  <LabelText className="image-header-font">{playerCardData?.firstName}</LabelText>
                  <LabelText className="image-header-font2">{playerCardData?.lastName}</LabelText>
                </div>
                <div style={{ display: 'flex', gap: '10px',paddingTop:'20px' }}>
                  <div style={{ display: 'flex', gap:'5px' }}>
                      <LabelText className="player-club-text">{playerCardData?.teamName}</LabelText>
                      <img src={`${apiUrls.ProxyImage}?url=${playerCardData?.currentTeamImageURL}`} width={20} height={20} style={{ borderRadius: '50%' }}/>
                  </div>
                  <div style={{ display: 'flex' , gap:'5px'}}> 
                      <LabelText className="player-club-text">{playerCardData?.nationalityName}</LabelText>
                      <img src={`./assets/country_flags/${playerCardData?.nationality}.svg`} width={20} height={20} style={{ borderRadius: '50%' }}/>
                  </div>
              </div>
                <div className="player-meta">
                  <LabelText className="player-club-text">{playerCardData?.position} - {playerCardData?.archetype}</LabelText><br />
                  <LabelText className="player-club-text2" style={{fontWeight:'250'}}>Age: {playerCardData?.age}</LabelText> &nbsp; <LabelText className="player-club-text2" style={{fontWeight:'250'}}>Height: {playerCardData?.height}cm</LabelText> &nbsp;
                  <LabelText className="player-club-text2" style={{fontWeight:'250'}}>Mins: {playerCardData?.playerStats?.totalMinutesOnField}</LabelText>
                </div>
              </div>
            </div>

            {/* Stats Section */}
            <div className="stats-section">
              <div className="box">
                <LabelText className="player-club-text">Match stats</LabelText>
                <div className="stat">
                  <div>
                      <LabelText className="player-club-text2">Goal / Assists</LabelText>
                      {/* <LabelText className="player-club-text3"> (per 90)</LabelText> */}
                  </div>
                  {/* <LabelText className="upper-lower-font">↑ 2</LabelText> */}
                  <span className="value">
                    <LabelText className="player-club-text">{playerCardData?.playerStats?.totalGoalsPer90} / {playerCardData?.playerStats?.totalAssistsPer90}</LabelText>
                  </span>
                </div>
                <div className="stat">
                  <div>
                      <LabelText className="player-club-text2">xGoal / xAssists</LabelText>
                      {/* <LabelText className="player-club-text3"> (per 90)</LabelText> */}
                  </div>
                  {/* <LabelText className="upper-lower-font">↑ 0.43</LabelText> */}
                    <span className="value"><LabelText className="player-club-text">{playerCardData?.playerStats?.averageXGoalsPer90.toFixed(2)} / {playerCardData?.playerStats?.averageXAssistsPer90.toFixed(2)}</LabelText></span>
                </div>
                <div className="stat">
                  <LabelText className="player-club-text2">Clean Sheets</LabelText>
                  {/* <LabelText className="upper-lower-font">↑ 0.43</LabelText> */}
                    <span className="value"><LabelText className="player-club-text">{playerCardData?.cleanSheet}</LabelText></span>
                </div>
                <div className="stat">
                  <div>
                      <LabelText className="player-club-text2">Defensive Contribution</LabelText>
                      {/* <LabelText className="player-club-text3"> (per 90)</LabelText> */}
                  </div>
                  {/* <LabelText className="upper-lower-font">↑ 0.43</LabelText> */}
                    <span className="value"><LabelText className="player-club-text">{playerCardData?.cbitScore}</LabelText></span>
                </div>
                <div className="stat">
                  <LabelText className="player-club-text2">Bookings</LabelText>
                  {/* <LabelText className="upper-lower-font">↑ 0.43</LabelText> */}
                  
                  <span className="value" style={{display:'flex', alignItems:'center'}}>
                      <LabelText className="player-club-text">{playerCardData?.playerStats?.totalYellowCards}</LabelText>
                      <img src={YellowCardSvg} alt="YellowCardSvg" />
                      {/* &nbsp;&nbsp; */}
                      <LabelText className="player-club-text">{playerCardData?.playerStats?.totalRedCards}</LabelText>
                      <img src={RedCardSvg} alt="RedCardSvg" />
                      {/* &nbsp;&nbsp; */}
                  </span>
                </div>
                {/* <div className="stat">
                  <LabelText className="player-club-text2">Minutes</LabelText>
                  <LabelText className="upper-lower-font">↑ 0.43</LabelText>
                  <span className="value">
                    <LabelText className="player-club-text">{playerCardData?.playerStats?.totalMinutesOnField}</LabelText>
                  </span>
                </div> */}
              </div>

              <div className="box">
                <LabelText className="player-club-text">Attributes Score</LabelText>
                {playerCardData?.attributesByPosition.map((attr, index) => (
                  <React.Fragment key={index}>
                    <div className="attr">
                      <LabelText className="player-club-text2">{attr?.attributeName!}</LabelText>
                      {/* <LabelText className="upper-lower-font">↑ {Math.floor(Math.random() * 10)}</LabelText> */}
                      <span className="value" style={{width:'15px',backgroundColor: getBackgroundColor(attr?.attributeValue!)}}>
                        <LabelText className="player-club-text" style={{color:'black'}}>{Math.floor(attr?.attributeValue!)}</LabelText>
                      </span>
                    </div>
                  </React.Fragment>
                ))}
                {/* <div className="attr">
                      <LabelText className="player-club-text2">Attack Contribution</LabelText>
                      <LabelText className="upper-lower-font">↑ {Math.floor(Math.random() * 10)}</LabelText>
                      <span className="value" style={{width:'15px',backgroundColor: playerCardData?.attackContribution! ? getBackgroundColor(Math.floor(playerCardData?.attackContribution!)) : 'transparent'}}>
                        <LabelText className="player-club-text" style={{color:'black'}}>{playerCardData?.attackContribution! ? Math.floor(playerCardData?.attackContribution!) : '--'}</LabelText>
                      </span>
                    </div> */}
                {/* <LabelText className="player-club-text">attribute name</LabelText>
                <div className="attr">
                  <LabelText className="player-club-text2">Finishing</LabelText>
                  <LabelText className="upper-lower-font">↑ 4</LabelText>
                  <span className="value">
                    <LabelText className="player-club-text">attribute value</LabelText>
                  </span>
                </div> */}
                {/* <div className="attr">
                  <LabelText className="player-club-text2">Dribbling</LabelText>
                  <LabelText className="upper-lower-font">↓ 2</LabelText>
                  <span className="value">
                    <LabelText className="player-club-text">{playerCardData?.playerStats?.dribbling}</LabelText>
                  </span>
                </div>
                <div className="attr">
                  <LabelText className="player-club-text2">Attack Positioning</LabelText>
                  <span className="value">
                    <LabelText className="player-club-text">59</LabelText>
                  </span>
                </div>
                <div className="attr">
                  <LabelText className="player-club-text2">Creativity</LabelText>
                  <span className="change up">↑ 1</span>
                  <span className="value">
                    <LabelText className="player-club-text">59</LabelText>
                  </span>
                </div> */}
              </div>
            </div>

            {/* Rankings Section */}
            {/* <div className="rankings">
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                  <LabelText className="image-header-font">In the</LabelText>
                  <LabelText className="image-header-font2">{playerCardData?.archetype}</LabelText>
                  <LabelText className="image-header-font">rankings</LabelText>
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                  <div>
                      <LabelText className="player-club-text2">{playerCardData?.competitionName}</LabelText> 
                      <LabelText className="upper-lower-font">↑ 1</LabelText>
                  </div>
                  <div>
                  <LabelText className="player-club-text2">{playerCardData?.areaName}</LabelText>
                      <LabelText className="upper-lower-font">↑ 10</LabelText>
                  </div>
                  <div>
                  <LabelText className="player-club-text2">Universe </LabelText>
                    <LabelText className="upper-lower-font"> ↑ 100</LabelText>
                  </div>
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:'5px',alignItems:'end'}}>
                  <span className="value">
                    <LabelText className="player-club-text">{playerCardData?.competitionRank} / {playerCardData?.competitionTotal}</LabelText>
                  </span>
                  <span className="value">
                    <LabelText className="player-club-text">{playerCardData?.areaRank} / {playerCardData?.areaTotal}</LabelText>
                  </span>
                  <span className="value">
                      <LabelText className="player-club-text">{playerCardData?.universalRank} / {playerCardData?.universalTotal}</LabelText>
                  </span>
              </div>
            </div> */}
          </div>
          {/* Download Button */}
          <PrimaryButton label="Download"  onClick={htmlToImageConvert} disabled={isPlayerCardLoading}/>
        {/* Styles */}
        {isPlayerCardLoading && <ModuleSpinner />}
      </div>
    );
};

export default PlayerCard;
